/* global window */
const getLoginCallbackParams = () => {
    let state = window.sessionStorage.getItem('auth_state');
    let origin = window.sessionStorage.getItem('auth_origin');
    window.sessionStorage.removeItem('auth_state');
    window.sessionStorage.removeItem('auth_origin');

    if (!state || !origin) {
        state = window.localStorage.getItem('auth_state');
        origin = window.localStorage.getItem('auth_origin');
        window.localStorage.removeItem('auth_state');
        window.localStorage.removeItem('auth_origin');
    }

    return {
        state,
        origin,
    };
};

const verifyLoginCallback = ({ location }) => {
    const { origin, state } = getLoginCallbackParams();

    if (state !== location.query.state) {
        return Promise.reject('invalid auth state');
    }

    return Promise.resolve({ origin });
};

export default verifyLoginCallback;



/** WEBPACK FOOTER **
 ** ./src/screens/auth-callback/verifyLoginCallback.js
 **/